/**
 * Interceptors support following methods:
 * request, response, requestError, responseError
 */

(function () {
	angular
		.module('trackeye')
		.factory('TokenInjector', TokenInjector);

	TokenInjector.$inject = ['AppFactory', '$injector', '$q'];

	function TokenInjector(AppFactory, $injector, $q) {
		var exports = {},
			apiUrl = AppFactory.getApiUrl();

		exports.request = function (config) {
			var AuthService = $injector.get('AuthService');
			
			if (config.__log === true) {
				DeviceService = $injector.get('DeviceService');
				if (!config.params) {
					config.params = {};
				}

				config.params.__nodeid = DeviceService.getSelectedDevice().getNodeId();
			}

			if (config.__token_injector === false) {
				return config;
			}

			try {
				var data = config.data || {};

				// This block serves to deny all api requests, if the application is in expire phase.
				// ie. waiting for credentials from the user.
				if (AuthService.isInExpirePhase() && isApiUrl(config.url) && !data.isAuthenicating) {
					_log('Expire phase, aborting', config.url);
					return $q.reject();
				}
			} catch (e) {
				console.error(e);
			}

			/**
			 * @TODO
			 * #192 - Should only check if an access token is available.
			 */
			if (AuthService.hasToken())
				config.headers['Authorization'] = 'Bearer ' + AuthService.getAccessToken();

			return config;
		};

		function isApiUrl (url) {
			return url.indexOf(apiUrl) >= 0;
		}

		return exports;
	}
})();